'use client';

import React, { useState } from 'react';
import {
  Edit2,
  Copy,
  Trash2,
  Eye,
  ChevronUp,
  ChevronDown,
  ChevronsUpDown,
  Warehouse,
  Star } from
'lucide-react';
import AppImage from '@/components/ui/AppImage';

// Backend integration: GET /api/seller/products?page=X&per_page=Y&search=...&category=...
const mockProducts = [
{
  id: 'prod-001',
  name: 'Samsung Galaxy A55 5G — 8GB/256GB Midnight Black',
  sku: 'SAM-A55-256-BLK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2e6e219-1772429765169.png",
  alt: 'Samsung Galaxy A55 smartphone in black color front view',
  category: 'Mobile & Tablets',
  brand: 'Samsung',
  price: 89999,
  salePrice: 84999,
  stock: 23,
  status: 'published' as const,
  featured: true,
  fba: true,
  variations: 3,
  createdAt: '12 Mar 2026'
},
{
  id: 'prod-002',
  name: 'Haier 1.5 Ton Inverter AC — HSU-18HFC(R410)',
  sku: 'HAI-AC-18T-WHT',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_109ebde21-1777427114403.png",
  alt: 'White Haier wall mounted air conditioner unit',
  category: 'Home Appliances',
  brand: 'Haier',
  price: 124500,
  salePrice: null,
  stock: 8,
  status: 'published' as const,
  featured: false,
  fba: false,
  variations: 0,
  createdAt: '08 Mar 2026'
},
{
  id: 'prod-003',
  name: 'Sony WH-1000XM5 Wireless Noise Cancelling Headphones',
  sku: 'SNY-WH-XM5-BK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18093efb3-1773063758472.png",
  alt: 'Black Sony over-ear noise cancelling headphones on white background',
  category: 'Audio & Headphones',
  brand: 'Sony',
  price: 62000,
  salePrice: 57500,
  stock: 15,
  status: 'published' as const,
  featured: true,
  fba: true,
  variations: 2,
  createdAt: '15 Feb 2026'
},
{
  id: 'prod-004',
  name: 'HP Victus 15 Gaming Laptop — Intel Core i5 12th Gen',
  sku: 'HP-VIC-15-I5-8G',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ef3d81d-1777043255349.png",
  alt: 'HP gaming laptop open with colorful screen and keyboard',
  category: 'Laptops & PCs',
  brand: 'HP',
  price: 185000,
  salePrice: 179000,
  stock: 4,
  status: 'published' as const,
  featured: false,
  fba: true,
  variations: 4,
  createdAt: '20 Jan 2026'
},
{
  id: 'prod-005',
  name: 'Logitech MX Master 3S Performance Wireless Mouse',
  sku: 'LOG-MXM3S-GR-WL',
  image: "https://images.unsplash.com/photo-1718882303675-c60df87433e0",
  alt: 'Gray Logitech MX Master 3S wireless mouse on desk surface',
  category: 'Accessories',
  brand: 'Logitech',
  price: 18500,
  salePrice: null,
  stock: 67,
  status: 'published' as const,
  featured: false,
  fba: false,
  variations: 2,
  createdAt: '05 Jan 2026'
},
{
  id: 'prod-006',
  name: 'Apple AirPods Pro (2nd Generation) — MagSafe Case',
  sku: 'APL-APP2-WHT-USB',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1336d6399-1772901666479.png",
  alt: 'White Apple AirPods Pro second generation in charging case',
  category: 'Audio & Headphones',
  brand: 'Apple',
  price: 78000,
  salePrice: 72000,
  stock: 3,
  status: 'published' as const,
  featured: true,
  fba: true,
  variations: 0,
  createdAt: '02 Apr 2026'
},
{
  id: 'prod-007',
  name: 'JBL Charge 5 Portable Bluetooth Speaker — Black',
  sku: 'JBL-CHG5-BLK-PK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_116019093-1765274487348.png",
  alt: 'Black JBL Charge 5 portable bluetooth speaker on wooden table',
  category: 'Audio & Headphones',
  brand: 'JBL',
  price: 28500,
  salePrice: 25000,
  stock: 6,
  status: 'published' as const,
  featured: false,
  fba: false,
  variations: 3,
  createdAt: '18 Mar 2026'
},
{
  id: 'prod-008',
  name: 'Canon EOS M50 Mark II Mirrorless Camera Body',
  sku: 'CAN-M50II-BK-BD',
  image: "https://images.unsplash.com/photo-1616949777341-eb7f00d05c63",
  alt: 'Black Canon EOS M50 Mark II mirrorless camera with lens attached',
  category: 'Cameras',
  brand: 'Canon',
  price: 145000,
  salePrice: null,
  stock: 2,
  status: 'pending_review' as const,
  featured: false,
  fba: false,
  variations: 0,
  createdAt: '09 May 2026'
},
{
  id: 'prod-009',
  name: 'Dell UltraSharp 27" 4K USB-C Monitor — P2723QE',
  sku: 'DEL-P2723QE-BK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1036d668a-1772401577033.png",
  alt: 'Dell UltraSharp 4K monitor showing desktop interface',
  category: 'Monitors',
  brand: 'Dell',
  price: 98500,
  salePrice: 94000,
  stock: 5,
  status: 'published' as const,
  featured: false,
  fba: true,
  variations: 0,
  createdAt: '22 Feb 2026'
},
{
  id: 'prod-010',
  name: 'Xiaomi Redmi Note 13 Pro — 8GB/256GB Midnight Black',
  sku: 'XMI-RN13P-256-BK',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a1740c00-1773054280551.png",
  alt: 'Xiaomi Redmi Note 13 Pro smartphone black color',
  category: 'Mobile & Tablets',
  brand: 'Xiaomi',
  price: 52000,
  salePrice: 48500,
  stock: 9,
  status: 'published' as const,
  featured: false,
  fba: false,
  variations: 4,
  createdAt: '14 Apr 2026'
},
{
  id: 'prod-011',
  name: 'Anker PowerCore 20000mAh PowerBank 20000mAh — Black',
  sku: 'ANK-PC20K-BK',
  image: "https://images.unsplash.com/photo-1564286027156-9ad736dfbbbb",
  alt: 'Black Anker portable power bank on white surface',
  category: 'Accessories',
  brand: 'Anker',
  price: 8500,
  salePrice: 7200,
  stock: 42,
  status: 'draft' as const,
  featured: false,
  fba: false,
  variations: 2,
  createdAt: '07 May 2026'
},
{
  id: 'prod-012',
  name: 'Corsair K95 RGB Platinum Mechanical Keyboard',
  sku: 'COR-K95-RGB-PLT',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17b673cd0-1772058626912.png",
  alt: 'Corsair K95 RGB mechanical gaming keyboard with colorful backlight',
  category: 'Accessories',
  brand: 'Corsair',
  price: 32000,
  salePrice: null,
  stock: 0,
  status: 'rejected' as const,
  featured: false,
  fba: false,
  variations: 0,
  createdAt: '01 May 2026'
}];


interface ProductTableProps {
  filters: {search: string;category: string;brand: string;status: string;stockLevel: string;};
  selectedIds: string[];
  onSelectAll: (ids: string[]) => void;
  onSelectOne: (id: string) => void;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

type SortKey = 'name' | 'price' | 'stock' | 'createdAt';
type SortDir = 'asc' | 'desc';

const statusDisplay: Record<string, React.ReactNode> = {
  published: <span className="status-published">Published</span>,
  draft: <span className="status-draft">Draft</span>,
  pending_review: <span className="status-pending-review">Pending Review</span>,
  rejected: <span className="status-rejected">Rejected</span>
};

export default function ProductTable({
  filters,
  selectedIds,
  onSelectAll,
  onSelectOne,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange
}: ProductTableProps) {
  const [sortKey, setSortKey] = useState<SortKey>('createdAt');
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const [toggleStates, setToggleStates] = useState<Record<string, {status: boolean;featured: boolean;}>>(
    Object.fromEntries(
      mockProducts.map((p) => [p.id, { status: p.status === 'published', featured: p.featured }])
    )
  );

  const handleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir((d) => d === 'asc' ? 'desc' : 'asc');else
    {setSortKey(key);setSortDir('asc');}
  };

  const filtered = mockProducts.filter((p) => {
    const q = filters.search.toLowerCase();
    if (q && !p.name.toLowerCase().includes(q) && !p.sku.toLowerCase().includes(q)) return false;
    if (filters.category && p.category.toLowerCase().replace(/\s+/g, '-') !== filters.category) return false;
    if (filters.brand && p.brand.toLowerCase() !== filters.brand) return false;
    if (filters.status && p.status !== filters.status) return false;
    if (filters.stockLevel === 'in_stock' && p.stock <= 10) return false;
    if (filters.stockLevel === 'low_stock' && (p.stock < 1 || p.stock > 10)) return false;
    if (filters.stockLevel === 'out_of_stock' && p.stock !== 0) return false;
    return true;
  });

  const sorted = [...filtered].sort((a, b) => {
    let av: number | string = 0,bv: number | string = 0;
    if (sortKey === 'name') {av = a.name;bv = b.name;} else
    if (sortKey === 'price') {av = a.price;bv = b.price;} else
    if (sortKey === 'stock') {av = a.stock;bv = b.stock;} else
    if (sortKey === 'createdAt') {av = a.createdAt;bv = b.createdAt;}
    if (av < bv) return sortDir === 'asc' ? -1 : 1;
    if (av > bv) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const paginated = sorted.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const allSelected = paginated.length > 0 && paginated.every((p) => selectedIds.includes(p.id));

  const SortIcon = ({ col }: {col: SortKey;}) => {
    if (sortKey !== col) return <ChevronsUpDown size={12} className="text-muted-foreground/50" />;
    return sortDir === 'asc' ? <ChevronUp size={12} className="text-primary" /> : <ChevronDown size={12} className="text-primary" />;
  };

  const toggleStatus = (id: string) => {
    // Backend integration: PATCH /api/seller/products/:id { status: 'published' | 'draft' }
    setToggleStates((prev) => ({
      ...prev,
      [id]: { ...prev[id], status: !prev[id].status }
    }));
  };

  const toggleFeatured = (id: string) => {
    // Backend integration: PATCH /api/seller/products/:id { featured: boolean }
    setToggleStates((prev) => ({
      ...prev,
      [id]: { ...prev[id], featured: !prev[id].featured }
    }));
  };

  const stockBadge = (stock: number) => {
    if (stock === 0) return <span className="badge-danger">Out of Stock</span>;
    if (stock <= 5) return <span className="badge-danger">{stock} left</span>;
    if (stock <= 10) return <span className="badge-warning">{stock} left</span>;
    return <span className="badge-success">{stock} in stock</span>;
  };

  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm min-w-[1100px]">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-10 px-4 py-3">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={() =>
                  allSelected ?
                  onSelectAll([]) :
                  onSelectAll(paginated.map((p) => p.id))
                  }
                  className="w-4 h-4 rounded border-border accent-primary cursor-pointer" />
                
              </th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('name')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Product <SortIcon col="name" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">SKU</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">Category</th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('price')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Price <SortIcon col="price" />
                </button>
              </th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('stock')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Stock <SortIcon col="stock" />
                </button>
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-muted-foreground">Featured</th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-muted-foreground">FBA</th>
              <th className="px-4 py-3 text-left">
                <button
                  onClick={() => handleSort('createdAt')}
                  className="flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground">
                  
                  Added <SortIcon col="createdAt" />
                </button>
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-muted-foreground">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 &&
            <tr>
                <td colSpan={11} className="py-16 text-center">
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center">
                      <Eye size={20} className="text-muted-foreground" />
                    </div>
                    <p className="text-sm font-semibold text-foreground">No products found</p>
                    <p className="text-xs text-muted-foreground">Try adjusting your search or filter criteria</p>
                  </div>
                </td>
              </tr>
            }
            {paginated.map((product) => {
              const isSelected = selectedIds.includes(product.id);
              const ts = toggleStates[product.id] ?? { status: false, featured: false };

              return (
                <tr
                  key={product.id}
                  className={`table-row-hover border-b border-border/50 last:border-0 group ${
                  isSelected ? 'bg-secondary/30' : ''}`
                  }>
                  
                  {/* Checkbox */}
                  <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => onSelectOne(product.id)}
                      className="w-4 h-4 rounded border-border accent-primary cursor-pointer" />
                    
                  </td>

                  {/* Product */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <AppImage
                        src={product.image}
                        alt={product.alt}
                        width={40}
                        height={40}
                        className="w-10 h-10 rounded-lg object-cover border border-border shrink-0" />
                      
                      <div className="min-w-0">
                        <p
                          className="text-xs font-semibold text-foreground leading-snug max-w-[200px] truncate"
                          title={product.name}>
                          
                          {product.name}
                        </p>
                        {product.variations > 0 &&
                        <p className="text-2xs text-muted-foreground mt-0.5">
                            {product.variations} variation{product.variations > 1 ? 's' : ''}
                          </p>
                        }
                      </div>
                    </div>
                  </td>

                  {/* SKU */}
                  <td className="px-4 py-3">
                    <code className="text-xs bg-muted px-1.5 py-0.5 rounded text-muted-foreground font-mono">
                      {product.sku}
                    </code>
                  </td>

                  {/* Category */}
                  <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">
                    {product.category}
                  </td>

                  {/* Price */}
                  <td className="px-4 py-3">
                    <div>
                      <p className="text-xs font-bold tabular-nums">
                        PKR {(product.salePrice ?? product.price).toLocaleString('en-PK')}
                      </p>
                      {product.salePrice &&
                      <p className="text-2xs text-muted-foreground line-through tabular-nums">
                          PKR {product.price.toLocaleString('en-PK')}
                        </p>
                      }
                    </div>
                  </td>

                  {/* Stock */}
                  <td className="px-4 py-3">{stockBadge(product.stock)}</td>

                  {/* Status toggle */}
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => toggleStatus(product.id)}
                        className={`relative w-9 h-5 rounded-full transition-colors duration-200 ${
                        ts.status ? 'bg-success' : 'bg-muted-foreground/30'}`
                        }
                        title={ts.status ? 'Click to unpublish' : 'Click to publish'}>
                        
                        <span
                          className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
                          ts.status ? 'translate-x-4' : 'translate-x-0.5'}`
                          } />
                        
                      </button>
                      {statusDisplay[product.status]}
                    </div>
                  </td>

                  {/* Featured toggle */}
                  <td className="px-4 py-3 text-center">
                    <button
                      onClick={() => toggleFeatured(product.id)}
                      className={`transition-colors duration-150 ${
                      ts.featured ? 'text-accent' : 'text-muted-foreground/40 hover:text-accent/60'}`
                      }
                      title={ts.featured ? 'Remove from featured' : 'Mark as featured'}>
                      
                      <Star size={16} fill={ts.featured ? 'currentColor' : 'none'} />
                    </button>
                  </td>

                  {/* FBA badge */}
                  <td className="px-4 py-3 text-center">
                    {product.fba ?
                    <span className="inline-flex items-center gap-1 text-2xs bg-primary text-white px-1.5 py-0.5 rounded font-bold">
                        <Warehouse size={10} /> FBA
                      </span> :

                    <span className="text-2xs text-muted-foreground/40">—</span>
                    }
                  </td>

                  {/* Created */}
                  <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">
                    {product.createdAt}
                  </td>

                  {/* Actions */}
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-primary"
                        title="Edit product">
                        
                        <Edit2 size={14} />
                      </button>
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-blue-600"
                        title="Duplicate product">
                        
                        <Copy size={14} />
                      </button>
                      <button
                        className="p-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
                        title="Preview product">
                        
                        <Eye size={14} />
                      </button>
                      <button
                        className="p-1.5 rounded-lg hover:bg-danger/10 transition-colors text-muted-foreground hover:text-danger"
                        title="Delete product — this cannot be undone">
                        
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>);

            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-border bg-muted/20">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>Rows per page:</span>
          <select
            value={pageSize}
            onChange={(e) => {onPageSizeChange(Number(e.target.value));onPageChange(1);}}
            className="input-field w-16 h-7 text-xs py-0 cursor-pointer">
            
            {[25, 50, 100].map((s) =>
            <option key={`pagesize-${s}`} value={s}>{s}</option>
            )}
          </select>
          <span>
            {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, sorted.length)} of {sorted.length}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <button
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">
            
            «
          </button>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">
            
            ‹
          </button>
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
            const page = start + i;
            return (
              <button
                key={`page-${page}`}
                onClick={() => onPageChange(page)}
                className={`w-7 h-7 rounded-lg text-xs font-medium transition-colors ${
                page === currentPage ?
                'bg-primary text-white' : 'btn-ghost'}`
                }>
                
                {page}
              </button>);

          })}
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">
            
            ›
          </button>
          <button
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="btn-ghost px-2 py-1 text-xs disabled:opacity-40">
            
            »
          </button>
        </div>
      </div>
    </div>);

}